module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"header":"Gratulerer, du er nå ferdig med å konfigurere enheten din!","infoMessage":"Enheten din er nå tilkoblet. Du kan nå lukke dette vinduet."},"en":{"header":"Congratulations, you are now finished with setting up your device!","infoMessage":"Your device is now connected. You may now close this window."}}')
  delete Component.options._Ctor
}
